exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ .ng-input input {\r\n  padding: 0;\r\n}\r\n\r\n:host /deep/ .ng-select {\r\n  width: 220px;\r\n}\r\n\r\n:host /deep/ .ng-dropdown-panel {\r\n  left: 0;\r\n}\r\n:host /deep/ .ng-select-container {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: row;\r\n      flex-direction: row;\r\n  -ms-flex-align: center !important;\r\n      align-items: center !important;\r\n}\r\n:host /deep/ .ng-input {\r\n  top: 0 !important;\r\n}\r\n:host /deep/ .ng-option {\r\n  width: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/enroll-record-list/enroll-record-list.component.css
// module id = ../../../../../src/app/enroll-record-list/enroll-record-list.component.css
// module chunks = main